import { render, staticRenderFns } from "./ResourceSelector.vue?vue&type=template&id=4c04c024&scoped=true"
import script from "./ResourceSelector.vue?vue&type=script&lang=js"
export * from "./ResourceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04c024",
  null
  
)

export default component.exports